define('home/templates/channelCardExplore',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return " has-image";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"card-content__media\">\n<div style=\"background-image: url("
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.image : depth0)) != null ? stack1.src : stack1), depth0))
    + ")\" class=\"img-cards\"></div>\n</div>\n";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1;

  return container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.threadOverrides : depth0)) != null ? stack1.title : stack1), depth0))
    + "\n";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1;

  return container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.thread : depth0)) != null ? stack1.clean_title : stack1), depth0))
    + "\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : {};

  return "<a href=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.thread : depth0)) != null ? stack1.link : stack1), depth0))
    + "\">\n<div class=\"card__header -feed\">\n<div class=\"card__reason -explore align align--middle\">\n<strong class=\"text-gray-darker\">"
    + ((stack1 = container.invokePartial(partials.forumName,((stack1 = (depth0 != null ? depth0.thread : depth0)) != null ? stack1.forum : stack1),{"name":"forumName","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "</strong>\n<time class=\"bullet text-gray\">"
    + alias2(alias1((depth0 != null ? depth0.relativeTime : depth0), depth0))
    + "</time>\n</div>\n</div>\n<div class=\"card__content -default"
    + ((stack1 = helpers["if"].call(alias3,(depth0 != null ? depth0.image : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\">\n"
    + ((stack1 = helpers["if"].call(alias3,(depth0 != null ? depth0.image : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "<div class=\"card-content__body\">\n<h2 class=\"discussion-title text-gray-darker\" dir=\"auto\">\n"
    + ((stack1 = helpers["if"].call(alias3,((stack1 = (depth0 != null ? depth0.threadOverrides : depth0)) != null ? stack1.title : stack1),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.program(7, data, 0),"data":data})) != null ? stack1 : "")
    + "</h2>\n\n<div class=\"card-content__summary text-gray-dark\">\n<div class=\"truncate\" data-truncate-lines=\"3\" dir=\"auto\">\n"
    + alias2(alias1((depth0 != null ? depth0.threadDescription : depth0), depth0))
    + "\n</div>\n</div>\n</div>\n</div>\n<div class=\"card__footer text-gray-dark text-semibold\">\n"
    + alias2(helpers.gettext.call(alias3,"%(recommendCount)s recommends",{"name":"gettext","hash":{"recommendCount":((stack1 = (depth0 != null ? depth0.thread : depth0)) != null ? stack1.likes : stack1)},"data":data}))
    + "\n<span class=\"bullet\"></span>\n"
    + alias2(helpers.gettext.call(alias3,"%(commentCount)s comments",{"name":"gettext","hash":{"commentCount":((stack1 = (depth0 != null ? depth0.thread : depth0)) != null ? stack1.posts : stack1)},"data":data}))
    + "\n</div>\n</a>\n";
},"usePartial":true,"useData":true})

});
